var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "35", height: "37", viewBox: "0 0 35 37", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M28.851 18.5v12H6.15v-12H4.375v13.875h26.25V18.5h-1.774z", fill: "#979797" }),
    React.createElement("path", { d: "M16.702 25.531V9.906c0-.207.1-.406.277-.552.177-.147.418-.229.669-.229.25 0 .491.082.669.229a.72.72 0 0 1 .277.552v15.625a.72.72 0 0 1-.277.553 1.056 1.056 0 0 1-.67.229c-.25 0-.49-.083-.668-.23a.72.72 0 0 1-.277-.552z", fill: "#979797" }),
    React.createElement("path", { d: "M17.558 25.208l6.666-6.48a.817.817 0 0 1 .57-.229c.213 0 .418.082.569.23a.771.771 0 0 1 .236.552.771.771 0 0 1-.236.553l-7.236 7.032a.807.807 0 0 1-.569.23.826.826 0 0 1-.57-.23l-7.235-7.032a.771.771 0 0 1-.235-.553c0-.207.084-.406.235-.553a.817.817 0 0 1 .57-.229c.213 0 .418.082.569.23l6.666 6.479z", fill: "#979797" })
  );
});